<app-category-filter></app-category-filter>
<p-divider></p-divider>
<div>
  <p-pickList
    class="app-pick-list"
    [source]="sourceList()"
    [target]="targetList()"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="showSourceControls"
    [showTargetControls]="showTargetControls"
    (onMoveToSource)="removeFromSelection($event)"
    (onMoveToTarget)="addToSelection($event)"
    (onMoveAllToSource)="removeFromSelection($event)"
    (onMoveAllToTarget)="addToSelection($event)"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
    breakpoint="1400px">
    <ng-template pTemplate="sourceHeader">
      <app-pick-list-header title="Bereiche" [count]="sourceList().length" />
    </ng-template>
    <ng-template pTemplate="targetHeader">
      <app-pick-list-header title="Auswahl" [count]="targetList().length">
        @if (hiddenSelectionCount(); as hidden) {
          <span
            end
            pTooltip="Durch den Filter ausgeblendet, bleiben aber ausgewählt.">
            +{{ hidden }} ausgeblendet
          </span>
        }
      </app-pick-list-header>
    </ng-template>
    <ng-template let-category pTemplate="item">
      <div class="pl-row">
        <i class="fas fa-folder pl-icon"></i>
        <div class="pl-body">
          <span class="pl-name">
            <span class="pl-prefix">{{ category.number }}</span>
            {{ category.name }}
          </span>
          @if (category.parent) {
            <span class="pl-meta">{{
              categoryStore.getPathById(category.parent)
            }}</span>
          }
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessagesource">
      <div class="pl-empty">Keine weiteren Einträge.</div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagesource">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
    <ng-template pTemplate="emptymessagetarget">
      <div class="pl-empty">
        Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen übernehmen.
      </div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagetarget">
      <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
    </ng-template>
  </p-pickList>
</div>
